var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4789 5.31349C19.2628 4.51023 18.6295 3.87703 17.8264 3.66074C16.3591 3.25928 10.49 3.25928 10.49 3.25928C10.49 3.25928 4.62113 3.25928 3.15388 3.64552C2.36619 3.86158 1.71742 4.51035 1.50136 5.31349C1.11523 6.78062 1.11523 9.82326 1.11523 9.82326C1.11523 9.82326 1.11523 12.8812 1.50136 14.333C1.71765 15.1362 2.35074 15.7694 3.154 15.9857C4.63658 16.3873 10.4902 16.3873 10.4902 16.3873C10.4902 16.3873 16.3591 16.3873 17.8264 16.001C18.6296 15.7848 19.2628 15.1516 19.4791 14.3485C19.8651 12.8812 19.8651 9.83871 19.8651 9.83871C19.8651 9.83871 19.8806 6.78062 19.4789 5.31349ZM8.62141 12.6342V7.01237L13.5019 9.82326L8.62141 12.6342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.5e5584d5650145e6ae720b5f63a6e2c4.svg";
export { ForwardRef as ReactComponent };